import React from 'react';

import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const StyledSwitch = styled(Switch)(({ theme }) => ({
	width: 30,
	height: 18,
	padding: 0,
	display: 'flex',
	'& .MuiSwitch-switchBase': {
		padding: 2,
		'&.Mui-checked': {
			transform: 'translateX(14px)',
			color: '#fff',
			'& + .MuiSwitch-track': {
				opacity: 1,
				backgroundColor: '#B1282E',
			},
		},
	},
	'& .MuiSwitch-thumb': {
		boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
		width: 12,
		height: 14,
		borderRadius: 2,
		transition: theme.transitions.create(['width'], {
			duration: 200,
		}),
	},
	'& .MuiSwitch-track': {
		borderRadius: 4,
		opacity: 1,
		backgroundColor: '#0F1820',
		boxSizing: 'border-box',
	},
}));

export default function DataViewSwitch({
	checked,
	onChange,
	leftText = 'Report',
	rightText = 'Graph',
	disabled = false,
	disabledText = 'View Switch disabled',
}) {
	const tooltipDisabledText = disabledText || '';

	return (
		<Tooltip title={disabled ? tooltipDisabledText : `Switch to ${ checked ? leftText : rightText} View`}>
			<Stack direction="row" spacing={1} alignItems="center">
				{ leftText && <Typography fontFamily='Saira, sans-serif'>{leftText}</Typography> }
				<StyledSwitch checked={checked} onChange={onChange} disabled={disabled} />
				{ rightText && <Typography fontFamily='Saira, sans-serif'>{rightText}</Typography> }
			</Stack>
		</Tooltip>
	);
}
